import { httpInstance } from '@/clients/http.request';
import { urlAbm, urlAfip, urlCaucion, urlFiles, urlMailBackend } from '@/helpers';
import { sendFallbackEmail } from '@/composables/useFallbackEmail';

export const uploadFileCaucion = async (_, data) => {
   const formData = new FormData();
   formData.append(data.type, data.file);
   formData.append('id_poliza', data.id_poliza);
   formData.append('type', data.type);

   try {
      const response = await httpInstance.post(
         `${urlFiles}/uploadCaucion`,
         formData,
         true,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const removeFileCaucion = async (_, data) => {
   try {
      const response = await httpInstance.delete(
         `${urlFiles}/removeFile?hash_id=${data}`,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const loadDataCaucion = async (_, data) => {
   try {
      await httpInstance.post(`${urlAbm}/referente`, {
         hash_id: data.hash_id,
         referente: data.referente,
      });
      const response = await httpInstance.post(
         `${urlCaucion}`,
         data.observaciones,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const updateDataCaucion = async (_, data) => {
   try {
      const response = await httpInstance.put(`${urlCaucion}/`, data);
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const loadReferenteCaucion = async (_, data) => {
   try {
      const response = await httpInstance.get(
         `${urlAfip}/${data.tipoDocumento}/${data.numeroDocumento}`,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const uploadFilesFormalidad = async (_, data) => {
   const formData = new FormData();
   formData.append('files', data.file);
   formData.append('id_poliza', data.id_poliza);
   try {
      const response = await httpInstance.post(
         `${urlFiles}/uploadCaucionFormalidad`,
         formData,
      );
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const formalidades = async (_) => {
   try {
      const response = await httpInstance.get(`${urlCaucion}/formalidades`);
      return response.data;
   } catch (error) {
      throw error;
   }
};

export const loadFormalidades = async (_, data) => {
   try {
      const response = await httpInstance.post(
         `${urlCaucion}/formalidad`,
         data,
      );
      return;
   } catch (error) {
      throw error;
   }
};

export const sendEmailCaucion = async ({ dispatch, rootState }, data) => {
   try {
      const id_poliza = rootState?.poliza?.poliza?.id_poliza;

      if (!id_poliza) {
         throw new Error('id_poliza es requerido');
      }

      await httpInstance.post(`${urlMailBackend}/sendEmailCaucion`, {
         id_poliza,
      });

      return { success: true };
   } catch (error) {
      try {
         await sendFallbackEmail({
            id_poliza: rootState?.poliza?.poliza?.id_poliza,
         });
      } catch (fallbackError) {
         console.error('Error al enviar fallback email:', fallbackError);
      }
      throw error;
   }
};
